import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const InstructorUtilizationChart = ({ data }) => {
  console.log("👨‍🏫 InstructorUtilizationChart received:", data);
  
  // Check if data exists
  if (!data || data.length === 0) {
    return (
      <div style={{ position: 'relative', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
        <p className="text-muted mb-2">Instructor utilization data not available</p>
        <small className="text-muted">This feature requires additional API endpoint configuration</small>
      </div>
    );
  }
  
  // Sort instructors by hours (descending) and take top 10
  const sortedInstructors = (data || [])
    .sort((a, b) => (b.hours || 0) - (a.hours || 0))
    .slice(0, 10);

  const chartData = {
    labels: sortedInstructors.map(i => i.instructor_name || 'Unknown'),
    datasets: [
      {
        label: 'Hours Sold',
        data: sortedInstructors.map(i => i.hours || 0),
        backgroundColor: 'rgba(153, 102, 255, 0.7)',
        borderColor: 'rgb(153, 102, 255)',
        borderWidth: 1
      },
      {
        label: 'Revenue Generated',
        data: sortedInstructors.map(i => (i.revenue || 0) / 1000), // Convert to thousands for better scale
        backgroundColor: 'rgba(255, 159, 64, 0.7)',
        borderColor: 'rgb(255, 159, 64)',
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 2.5,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          padding: 15
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.datasetIndex === 0) {
              // Hours
              label += context.parsed.y.toLocaleString() + ' hrs';
            } else {
              // Revenue (multiply back by 1000)
              label += new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0
              }).format(context.parsed.y * 1000);
            }
            return label;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Hours / Revenue (in thousands)'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        grid: {
          display: false
        },
        ticks: {
          maxRotation: 45,
          minRotation: 45
        }
      }
    }
  };

  return (
    <div style={{ position: 'relative', height: '400px' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default InstructorUtilizationChart;